import { HIRING_PROCESS } from "@/data/content";

export default function HiringProcess() {
  return (
    <section data-testid="process-section" className="py-20 sm:py-24 lg:py-28 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-3xl reveal">
          <p className="text-xs sm:text-sm font-bold uppercase tracking-[0.2em] text-primary">Our Process</p>
          <h2 className="mt-3 font-heading font-bold text-3xl sm:text-4xl lg:text-5xl text-slate-900 leading-tight tracking-tight">
            A precise 7-step hiring process
          </h2>
          <p className="mt-5 text-base sm:text-lg text-slate-600 leading-relaxed">
            Engineered for speed, quality and complete transparency at every stage.
          </p>
        </div>

        <div className="mt-16 relative">
          {/* Vertical line for mobile, horizontal for desktop */}
          <div className="hidden lg:block absolute top-12 left-0 right-0 h-px bg-gradient-to-r from-transparent via-slate-200 to-transparent" />

          <ol className="grid lg:grid-cols-7 gap-8 lg:gap-4">
            {HIRING_PROCESS.map((s, i) => (
              <li key={s.step} data-testid={`process-step-${i}`} className="relative">
                <div className="flex lg:flex-col items-start lg:items-center gap-4 lg:gap-0">
                  <div className="relative shrink-0">
                    <div className="w-16 h-16 lg:w-20 lg:h-20 rounded-2xl bg-white border-2 border-primary/20 flex items-center justify-center shadow-sm">
                      <span className="font-heading font-extrabold text-xl lg:text-2xl text-primary">{s.step}</span>
                    </div>
                    <div className="absolute -top-1 -right-1 w-3 h-3 rounded-full bg-primary lg:hidden" />
                  </div>
                  <div className="lg:mt-5 lg:text-center">
                    <h3 className="font-heading font-bold text-base text-slate-900 leading-snug">{s.title}</h3>
                    <p className="mt-1.5 text-xs sm:text-sm text-slate-600 leading-relaxed lg:px-1">{s.text}</p>
                  </div>
                </div>
              </li>
            ))}
          </ol>
        </div>
      </div>
    </section>
  );
}
